import getURLSearchParam from '../base/url'
import { APP_NAME } from './typing'

enum QUERY_PARAM_KEY {
  mina_name = 'mina_name',
  programName = 'programName',
  referMiniProgram = 'referMiniProgram',
}

type I_WXAPP_NAME_MAP = Partial<{
  'meituan-wxapp': string
  'dianping-wxapp': string
  'hotel-wxapp': string
  'zhenguo-wxapp': string
  'zhenguo-swan': string
  mt: string
  dp: string
  hotel: string
  weChat_mt: string
  weChat_dp: string
  weChat: string
  'mt-weapp': string
  [x: string]: any
}>

export enum WXAPP_NAME {
  group_wxapp = 'group_wxapp',
  dianping_wxapp = 'dianping_wxapp',
  hotel_wxapp = 'hotel_wxapp',
  ticket_wxapp = 'ticket_wxapp',
  phoenix_wxapp = 'phoenix_wxapp',
  phoenix_bdapp = 'phoenix_bdapp',
  phoenix_xhsapp = 'phoenix_xhsapp',
}

enum WEBVIEW_TYPE {
  phxMpWebview = 'phxMpWebview',
  groupMpWebview = 'groupMpWebview',
  dianpingMpWebview = 'dianpingMpWebview',
  hotelMpWebview = 'hotelMpWebview',
  ticketMpWebview = 'ticketMpWebview',
}

interface I_WEBVIEW {
  appnm: WXAPP_NAME
  type: WEBVIEW_TYPE
}

function webviewMap(type: WEBVIEW_TYPE, param: QUERY_PARAM_KEY, map: I_WXAPP_NAME_MAP) {
  const mark = getURLSearchParam(param)
  if (!mark) return undefined
  const appnm: WXAPP_NAME = map[mark]
  return appnm ? { type, appnm } : undefined
}

// 点评小程序无法直接通过 mina_name 区分，所以增加这个判断
const isPhxWxWebview = getURLSearchParam('request_client') === 'miniprogram'

type CheckWebviewTypeFn = (ua: string) =>
  | {
      type: WEBVIEW_TYPE
      appnm: WXAPP_NAME
    }
  | undefined

const checkWebviewType: Record<WEBVIEW_TYPE, CheckWebviewTypeFn> = {
  [WEBVIEW_TYPE.phxMpWebview](ua) {
    return webviewMap(WEBVIEW_TYPE.phxMpWebview, QUERY_PARAM_KEY.mina_name, {
      'meituan-wxapp': WXAPP_NAME.group_wxapp,
      'dianping-wxapp': isPhxWxWebview ? WXAPP_NAME.dianping_wxapp : '',
      'hotel-wxapp': WXAPP_NAME.hotel_wxapp,
      'zhenguo-wxapp': WXAPP_NAME.phoenix_wxapp,
      'zhenguo-swan':
        (ua.indexOf('swan-baidu') !== -1 && WXAPP_NAME.phoenix_bdapp) ||
        (ua.indexOf('swan-xhs') !== -1 && WXAPP_NAME.phoenix_xhsapp) ||
        WXAPP_NAME.phoenix_xhsapp,
    })
  },
  [WEBVIEW_TYPE.hotelMpWebview]() {
    return webviewMap(WEBVIEW_TYPE.hotelMpWebview, QUERY_PARAM_KEY.programName, {
      mt: WXAPP_NAME.group_wxapp,
      dp: WXAPP_NAME.dianping_wxapp,
      hotel: WXAPP_NAME.hotel_wxapp,
    })
  },
  [WEBVIEW_TYPE.ticketMpWebview]() {
    return webviewMap(WEBVIEW_TYPE.ticketMpWebview, QUERY_PARAM_KEY.referMiniProgram, {
      weChat_mt: WXAPP_NAME.group_wxapp,
      weChat_dp: WXAPP_NAME.dianping_wxapp,
      weChat: WXAPP_NAME.ticket_wxapp,
    })
  },
  [WEBVIEW_TYPE.groupMpWebview]() {
    return webviewMap(WEBVIEW_TYPE.groupMpWebview, QUERY_PARAM_KEY.mina_name, {
      'mt-weapp': WXAPP_NAME.group_wxapp,
    })
  },
  [WEBVIEW_TYPE.dianpingMpWebview]() {
    return webviewMap(WEBVIEW_TYPE.dianpingMpWebview, QUERY_PARAM_KEY.mina_name, {
      'dianping-wxapp': !isPhxWxWebview ? WXAPP_NAME.dianping_wxapp : '',
    })
  },
}

export type I_MP_AGENT =
  | {
      appnm: APP_NAME
      version: string
      [x: string]: any
    }
  | undefined

// 注：小程序和webview是一对多的关系
export default function miniapp(_ua: string): I_MP_AGENT {
  const ua = _ua.toLowerCase()
  let webview: I_WEBVIEW | undefined
  for (const key of Object.keys(checkWebviewType)) {
    webview = checkWebviewType[key as keyof typeof WEBVIEW_TYPE].call(null, ua)
    if (webview) {
      break
    }
  }
  if (!webview) {
    return undefined
  }
  return {
    appnm: webview.appnm,
    [webview.appnm]: true,
    [webview.type]: true,
    version: getURLSearchParam('mina_version'),
  }
}
